import {MS_IN_MINUTE} from '/constant/time.constant';

export const MIN_LOGGED_IN_TIMES_TO_SHOW_ALERT = 2;
export const SECOND_PROMPT_AFTER_LOGIN = 4;

export const MIN_TIME_PASSED_BEFORE_SHOW_ALERT = 2 * MS_IN_MINUTE;

export const APPLE_APP_ID = '1518841061';
export const GOOGLE_PACKAGE_NAME = 'com.optaviaconnect';

export const NUMBER_OF_TIMES_USER_LOGGED_IN = 'NUMBER_OF_TIMES_USER_LOGGED_IN';
export const RATE_ALERT_SHOWN_BEFORE = 'RATE_ALERT_SHOWN_BEFORE';
